import 'custom-event-polyfill'; // IE11 event polyfill
import 'whatwg-fetch'; // IE11 fetch polyfill
import 'formdata-polyfill'; // IE11 form data polyfill
import 'intersection-observer'; // IE11 intersection observer polyfill

import 'lazysizes';
import 'lazysizes/plugins/bgset/ls.bgset';

import initAccordions from './app/accordions';
import initTabs from './app/tabs';
import initModals from './app/modals';
import initVideoModals from './app/video-modals';
import initLocationFilters from './app/location-filters';
import initSticky from './app/sticky';

IntersectionObserver.prototype.POLL_INTERVAL = 100; // Time in milliseconds.

initAccordions();
initTabs();
initModals();
initVideoModals();
initLocationFilters();
initSticky();

jQuery(document).ready(function ($) {
  // Hamburger Menu
  $('header.header button.mobile-menu-button').click(function () {
    $('header.header').toggleClass('mobile-menu-active');
    $('header.header .hamburger').toggleClass('is-active');
  });

  // Hide on click/tap outside menu
  $(document).click(function (event) {
    var $target = $(event.target);
    if (!$target.closest('.primary-nav').length && !$target.closest('.mobile-menu-button').length && !$target.closest('.search').length) {
      $('header').removeClass('mobile-menu-active');
    }
  });

  // Desktop Menus
  $('ul.main-menu > li').hoverIntent({
    over: showMenuPanel,
    out: hideMenuPanel,
    timeout: 500
  });

  $('ul.main-menu > li').click(function () {
    $(this).toggleClass('sub-menu-active');
  });

  function showMenuPanel() {
    $('header li').removeClass('sub-menu-active');
    $(this).addClass('sub-menu-active');
  }

  function hideMenuPanel() {
    $(this).removeClass('sub-menu-active');
  }

  // Search controls

  $('.search__toggle').click(function () {
    $('.header').addClass('search-form-active');
    $('#search_input').focus();
  })

  $('.search__button-close').click(function () {
    $('.header').removeClass('search-form-active');
  })

  $('.search__button-search').click(function () {
    window.location.href = '/?s=' + encodeURI($('#search_input').val());
  });

  // Hide search on esc press, redirect to search if enter pressed AND search box is focused
  $(document).on('keyup', function (evt) {
    if (evt.keyCode == 27) {
      $('.header').removeClass('search-form-active');
    } else if ($('#search_input').is(':focus') && (evt.keyCode == 13)) {
      window.location.href = '/?s=' + encodeURI($('#search_input').val());
    }
  });

  // Hide search if user clicks elsewhere
  $(window).click(function () {
    $('.header').removeClass('search-form-active');
  });

  $('.header').click(function (event) {
    event.stopPropagation();
  });

});

// Gallery on Single Location details page
jQuery(document).ready(function ($) {
  if (document.body.classList.contains('single-location')) {
    $('#gallery .slider-content').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      infinite: false,
      asNavFor: '#gallery .menu'
    });

    $('#gallery .menu').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.slider-content',
      dots: false,
      centerMode: false,
      focusOnSelect: true,
      infinite: false,
      arrows: true
    });

    /**
     * Custom Slick init to load/unload iframe src on events
     */
    $('.slider-content').slickLightbox({
      closeOnBackdropClick: false,
      slick: function ($e) {

        $e.find('.slick-lightbox-slick-iframe').each(function () {
          $(this)
            .attr('data-src', $(this).attr('src'))
            .attr('src', '')
        })

        function clearIframe(slick, index) {
          var $iframe = $(slick.$slides.get(index)).find('.slick-lightbox-slick-iframe')
          if ($iframe.length) {
            setTimeout(function () {
              $iframe.attr('src', '')
            }, slick.options.speed)
          }
        }

        function loadIframe(slick, index) {
          var $iframe = $(slick.$slides.get(index)).find('.slick-lightbox-slick-iframe')
          if ($iframe.length) $iframe.attr('src', $iframe.attr('data-src'))
        }

        /**
         * Return slick instance
         */
        return $e.find('.slick-lightbox-slick')
          .on('init', function (event, slick) {
            loadIframe(slick, slick.currentSlide)
          })
          .on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            clearIframe(slick, currentSlide)
            loadIframe(slick, nextSlide)
          })
          .slick()
      }
    });

    $('#slick-lightbox-btn').on('click', function (e) {
      e.preventDefault();
      $('.item:first-child A', '.slider-content').click();
    });

    // Single location jump links
    // Request more info button
    $('#scrollto-application').on('click', function (e) {
      e.preventDefault();
      $('html, body').animate({ scrollTop: $('#application').offset().top - 200 }, 'slow');
    });
    // Price link
    $('#scrollto-pricing').on('click', function (e) {
      e.preventDefault();
      $('html, body').animate({ scrollTop: $('#pricing').offset().top - 200 }, 'slow');
    });
    // Floor Plans link
    $('#scrollto-floor-plans').on('click', function (e) {
      e.preventDefault();
      $('html, body').animate({ scrollTop: $('#floor-plans').offset().top - 200 }, 'slow');
    });

  }
});

// Tabs on Single Location details page
window.addEventListener("DOMContentLoaded", () => {

  if (document.body.classList.contains('single-location')) {

    const tabs = document.querySelectorAll('.single-location [role="tab"]');
    const tabList = document.querySelector('.single-location [role="tablist"]');
    document.querySelector('.single-location [role="tablist"] button:first-child').classList.add('selected');

    // Add a click event handler to each tab
    tabs.forEach(tab => {
      tab.addEventListener("click", changeTabs);
    });

    // Enable arrow navigation between tabs in the tab list
    let tabFocus = 0;

    tabList.addEventListener("keydown", e => {
      // Move right
      if (e.keyCode === 39 || e.keyCode === 37) {
        tabs[tabFocus].setAttribute("tabindex", -1);
        if (e.keyCode === 39) {
          tabFocus++;
          // If we're at the end, go to the start
          if (tabFocus >= tabs.length) {
            tabFocus = 0;
          }
          // Move left
        } else if (e.keyCode === 37) {
          tabFocus--;
          // If we're at the start, move to the end
          if (tabFocus < 0) {
            tabFocus = tabs.length - 1;
          }
        }

        tabs[tabFocus].setAttribute("tabindex", 0);
        tabs[tabFocus].focus();
      }
    });
  }
});

function changeTabs(e) {
  const target = e.target;
  const parent = target.parentNode;
  const grandparent = parent.parentNode;
  document.querySelector('.single-location [role="tablist"] button').classList.remove('selected');

  // Remove all current selected tabs
  parent
    .querySelectorAll('[aria-selected="true"]')
    .forEach(t => t.setAttribute("aria-selected", false));

  // Set this tab as selected
  target.setAttribute("aria-selected", true);
  target.classList.add('selected');

  // Hide all tab panels
  grandparent
    .querySelectorAll('[role="tabpanel"]')
    .forEach(p => p.setAttribute("hidden", true));

  // Show the selected panel
  grandparent.parentNode
    .querySelector(`#${target.getAttribute("aria-controls")}`)
    .removeAttribute("hidden");
}
/*!
 * hoverIntent v1.10.1 // 2019.10.05 // jQuery v1.7.0+
 * http://briancherne.github.io/jquery-hoverIntent/
 *
 * You may use hoverIntent under the terms of the MIT license. Basically that
 * means you are free to use hoverIntent as long as this header is left intact.
 * Copyright 2007-2019 Brian Cherne
 */
!function (factory) { "use strict"; "function" == typeof define && define.amd ? define(["jquery"], factory) : "object" == typeof module && module.exports ? module.exports = factory(require("jquery")) : jQuery && !jQuery.fn.hoverIntent && factory(jQuery) }(function ($) { "use strict"; function track(ev) { cX = ev.pageX, cY = ev.pageY } var cX, cY, _cfg = { interval: 100, sensitivity: 6, timeout: 0 }, INSTANCE_COUNT = 0, compare = function (ev, $el, s, cfg) { if (Math.sqrt((s.pX - cX) * (s.pX - cX) + (s.pY - cY) * (s.pY - cY)) < cfg.sensitivity) return $el.off(s.event, track), delete s.timeoutId, s.isActive = !0, ev.pageX = cX, ev.pageY = cY, delete s.pX, delete s.pY, cfg.over.apply($el[0], [ev]); s.pX = cX, s.pY = cY, s.timeoutId = setTimeout(function () { compare(ev, $el, s, cfg) }, cfg.interval) }; $.fn.hoverIntent = function (handlerIn, handlerOut, selector) { var instanceId = INSTANCE_COUNT++, cfg = $.extend({}, _cfg); $.isPlainObject(handlerIn) ? (cfg = $.extend(cfg, handlerIn), $.isFunction(cfg.out) || (cfg.out = cfg.over)) : cfg = $.isFunction(handlerOut) ? $.extend(cfg, { over: handlerIn, out: handlerOut, selector: selector }) : $.extend(cfg, { over: handlerIn, out: handlerIn, selector: handlerOut }); function handleHover(e) { var ev = $.extend({}, e), $el = $(this), hoverIntentData = $el.data("hoverIntent"); hoverIntentData || $el.data("hoverIntent", hoverIntentData = {}); var state = hoverIntentData[instanceId]; state || (hoverIntentData[instanceId] = state = { id: instanceId }), state.timeoutId && (state.timeoutId = clearTimeout(state.timeoutId)); var mousemove = state.event = "mousemove.hoverIntent.hoverIntent" + instanceId; if ("mouseenter" === e.type) { if (state.isActive) return; state.pX = ev.pageX, state.pY = ev.pageY, $el.off(mousemove, track).on(mousemove, track), state.timeoutId = setTimeout(function () { compare(ev, $el, state, cfg) }, cfg.interval) } else { if (!state.isActive) return; $el.off(mousemove, track), state.timeoutId = setTimeout(function () { !function (ev, $el, s, out) { var data = $el.data("hoverIntent"); data && delete data[s.id], out.apply($el[0], [ev]) }(ev, $el, state, cfg.out) }, cfg.timeout) } } return this.on({ "mouseenter.hoverIntent": handleHover, "mouseleave.hoverIntent": handleHover }, cfg.selector) } });
